import { NextPageContext } from 'next'

import { JournalFormData, JournalSubmitPayload } from './types'

export const CHANGE_JOURNAL_FORM_FIELD = 'CHANGE_JOURNAL_FORM_FIELD'
export const SUBMIT_JOURNAL = 'SUBMIT_JOURNAL'
export const VALIDATE_JOURNAL_FIELD = 'VALIDATE_JOURNAL_FIELD'
export const ADD_JOURNAL_FIELD_ERROR = 'ADD_JOURNAL_FIELD_ERROR'
export const ADD_JOURNAL_FIELDS_ERRORS = 'ADD_JOURNAL_FIELDS_ERRORS'
export const CLEAR_JOURNAL_FIELD_ERROR = 'CLEAR_JOURNAL_FIELD_ERROR'
export const RESET_JOURNAL_FORM_DATA = 'RESET_JOURNAL_FORM_DATA'
export const PREDEFINE_JOURNAL_FORM_DATA = 'PREDEFINE_JOURNAL_FORM_DATA'
export const LOAD_JOURNAL_DETAILS_PAGE_DATA = 'LOAD_JOURNAL_DETAILS_PAGE_DATA'

interface ChangeJournalFormFieldAction {
  type: typeof CHANGE_JOURNAL_FORM_FIELD
  payload: {
    key: keyof JournalFormData
    value: string
  }
}

interface SubmitJournalAction {
  type: typeof SUBMIT_JOURNAL
  payload: JournalSubmitPayload
}

interface ValidateFieldAction {
  type: typeof VALIDATE_JOURNAL_FIELD
  payload: {
    field: string
    value: string
    validations: string
  }
}

interface AddFieldErrorAction {
  type: typeof ADD_JOURNAL_FIELD_ERROR
  payload: {
    field: string
    error: string
  }
}

interface AddFieldsErrorsAction {
  type: typeof ADD_JOURNAL_FIELDS_ERRORS
  payload: {
    errors: Record<string, string>
  }
}

interface ClearFieldErrorAction {
  type: typeof CLEAR_JOURNAL_FIELD_ERROR
  payload: {
    field: string
  }
}

interface ResetJournalFormDataAction {
  type: typeof RESET_JOURNAL_FORM_DATA
}

interface PredefineJournalFormAction {
  type: typeof PREDEFINE_JOURNAL_FORM_DATA
  payload: Partial<JournalFormData>
}

interface LoadJournalPageDataAction {
  type: typeof LOAD_JOURNAL_DETAILS_PAGE_DATA
  payload: {
    urlParams?: { personId: string }
    req?: NextPageContext['req']
  }
}

export type JournalActionTypes =
  | ChangeJournalFormFieldAction
  | SubmitJournalAction
  | ValidateFieldAction
  | AddFieldErrorAction
  | AddFieldsErrorsAction
  | ClearFieldErrorAction
  | ResetJournalFormDataAction
  | PredefineJournalFormAction
  | LoadJournalPageDataAction

export function changeJournalFormField(
  key: keyof JournalFormData,
  value: string,
): ChangeJournalFormFieldAction {
  return {
    type: CHANGE_JOURNAL_FORM_FIELD,
    payload: {
      key,
      value,
    },
  }
}

export function submitJournal(payload: JournalSubmitPayload): SubmitJournalAction {
  return {
    type: SUBMIT_JOURNAL,
    payload,
  }
}

export function addFieldError({
  field,
  error,
}: {
  field: string
  error: string
}): AddFieldErrorAction {
  return {
    type: ADD_JOURNAL_FIELD_ERROR,
    payload: {
      error,
      field,
    },
  }
}

export function addFieldsErrors(errors: Record<string, string>): AddFieldsErrorsAction {
  return {
    type: ADD_JOURNAL_FIELDS_ERRORS,
    payload: {
      errors,
    },
  }
}

export function clearFieldError({ field }: { field: string }): ClearFieldErrorAction {
  return {
    type: CLEAR_JOURNAL_FIELD_ERROR,
    payload: {
      field,
    },
  }
}

export function resetJournalFormData(): ResetJournalFormDataAction {
  return {
    type: RESET_JOURNAL_FORM_DATA,
  }
}

export function validateField({
  field,
  value,
  validations,
}: {
  field: string
  value: string
  validations: string
}): ValidateFieldAction {
  return {
    type: VALIDATE_JOURNAL_FIELD,
    payload: {
      field,
      value,
      validations,
    },
  }
}

export function predefineJournalForm(data: Partial<JournalFormData>): PredefineJournalFormAction {
  return {
    type: PREDEFINE_JOURNAL_FORM_DATA,
    payload: data,
  }
}

export function loadJournalPageData(payload: {
  urlParams?: { personId: string }
  req?: NextPageContext['req']
}): LoadJournalPageDataAction {
  return {
    type: LOAD_JOURNAL_DETAILS_PAGE_DATA,
    payload,
  }
}
